export * from './filter-group-template';
export * from './filter-item-template';

import { FilterGroupTemplateComponent } from './filter-group-template';
import { FilterItemTemplateComponent } from './filter-item-template';

export const FilterMolecules = [
    FilterGroupTemplateComponent,
    FilterItemTemplateComponent
]